import React from 'react'
import { Logo } from '../ui/Logo'
import { Linkedin, Facebook, Instagram, Youtube } from 'lucide-react'

export const PublicFooter: React.FC = () => {
  // X (formerly Twitter) icon as SVG component
  const XIcon = ({ className }: { className?: string }) => (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  )

  const socialLinks = [
    {
      name: 'X',
      icon: XIcon,
      href: 'https://x.com/open1031',
      color: 'hover:text-[#000000] dark:hover:text-[#ffffff]'
    },
    {
      name: 'LinkedIn',
      icon: Linkedin,
      href: 'https://linkedin.com/company/open1031',
      color: 'hover:text-[#0077B5]'
    },
    {
      name: 'Facebook',
      icon: Facebook,
      href: 'https://facebook.com/open1031',
      color: 'hover:text-[#1877F2]'
    },
    {
      name: 'Instagram',
      icon: Instagram,
      href: 'https://instagram.com/open1031',
      color: 'hover:text-[#E4405F]'
    },
    {
      name: 'YouTube',
      icon: Youtube,
      href: 'https://youtube.com/@open1031',
      color: 'hover:text-[#FF0000]'
    }
  ]

  return (
    <footer className="py-12 relative z-10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto bg-white/60 dark:bg-slate-800/60 backdrop-blur-3xl rounded-[28px] shadow-[0_8px_32px_rgba(0,0,0,0.08),0_2px_8px_rgba(0,0,0,0.04)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.3),0_2px_8px_rgba(0,0,0,0.2)] border border-white/60 dark:border-slate-700/60 ring-1 ring-black/[0.03] dark:ring-white/[0.05] p-8 md:p-10 transform-gpu">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex flex-col items-center md:items-start gap-3">
              <Logo className="h-10 w-auto" />
              <div className="text-center md:text-left">
                <p className="text-slate-900 dark:text-slate-100 text-sm font-bold">Open1031, Inc.</p>
                <p className="text-slate-500 dark:text-slate-400 text-xs mt-1">
                  Copyright &copy; {new Date().getFullYear()} All Rights Reserved.
                </p>
                <p className="text-slate-500 dark:text-slate-400 text-xs mt-2">
                  The complete 1031 exchange platform for modern investors.
                </p>
              </div>
            </div>
            
            {/* Social Media Icons */}
            <div className="flex items-center gap-4">
              {socialLinks.map((social) => {
                const Icon = social.icon
                return (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`group flex items-center justify-center w-10 h-10 rounded-xl bg-slate-100 dark:bg-slate-700/50 text-slate-600 dark:text-slate-400 transition-all duration-300 ${social.color} hover:bg-slate-200 dark:hover:bg-slate-600 hover:scale-110 hover:shadow-lg`}
                    aria-label={`Follow us on ${social.name}`}
                  >
                    <Icon className="h-5 w-5 transition-transform duration-300 group-hover:scale-110" />
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

